import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import routes from '@/config/routes';
import { AttendanceStatus } from '@/store/enums';
import { AttendanceType } from '@/store/enums';
import { FULFILLED_ACTION, MARK_ATTENDANCE_FAILURE_STATUS_CODE, REJECTED_ACTION } from '@/config/variables';
import { useAppDispatch } from '@/hooks';
import { markAttendance } from '@/store/slices/su/classDetailsSlice';

const MarkAttendance = (): React.ReactElement => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [attendanceStatus, setAttendanceStatus] = useState('');
  const isLoggedIn = localStorage.getItem('isLoggedIn');

  const handleMarkAttendance = async () => {
    const urlParts = window.location.href?.split('/');
    const timetableIdHash = urlParts[urlParts?.length - 1];
    const timetableID = Number(urlParts[urlParts?.length - 2]);

    if (!timetableID || !timetableIdHash) return;

    if (Boolean(isLoggedIn)) {
      const payload = {
        timetableID,
        timetableIdHash,
      };
      dispatch(markAttendance(payload)).then(response => {
        if (response.meta.requestStatus === FULFILLED_ACTION) {
          setAttendanceStatus(response.payload.data);
          return;
        }
        if (response.meta.requestStatus === REJECTED_ACTION) {
          if (response.payload.status === MARK_ATTENDANCE_FAILURE_STATUS_CODE) {
            setAttendanceStatus(response.payload.data);
            return;
          }
          setAttendanceStatus(t('attendanceDetails.serverError'));
          return;
        }
      });
      return;
    }
    localStorage.setItem(AttendanceType.AttendanceSessionKey, JSON.stringify({ timetableID, timetableIdHash }));
    history.push(routes.root);
    return;
  };

  useEffect(() => {
    handleMarkAttendance();
  }, []);

  const getStatusText = () => {
    if (attendanceStatus === AttendanceStatus.ERROR_NOT_YOUR_CLASS) {
      return t('attendanceDetails.notYourClass');
    }
    if (attendanceStatus === AttendanceStatus.ERROR_INVALID_LINK) {
      return t('attendanceDetails.invalidLink');
    }
    if (attendanceStatus === AttendanceStatus.SUCCESS) {
      return t('attendanceDetails.attendanceMarkedSuccessfully');
    }
    return;
  };

  return (
    <div className="m-auto mt-4">
      <StyledStatus>{getStatusText()}</StyledStatus>
    </div>
  );
};

export const StyledStatus = styled.p`
  color: #0a4599;
  font-size: 2rem;
  font-weight: 300;
`;

export default MarkAttendance;
